import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";

export default function StudentsView() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [data, setData] = useState(null);

    useEffect(() => {
        const saved = JSON.parse(localStorage.getItem("students")) || [];
        const student = saved.find((s) => String(s.id) === String(id));
        setData(student);
    }, [id]);

    if (!data) return <h3 style={{ padding: 20 }}>No Data Found</h3>;

    const GridSection = ({ title, children }) => (
        <div style={{ marginBottom: 30 }}>
            <h3 style={{
                color: '#007BFF',
                fontSize: '24px',
                fontWeight: 600,
                margin: '20px 0 15px 0',
                padding: '8px 0',
                borderBottom: '2px solid #F1F1F1',
            }}>
                {title}
            </h3>

            <div style={{
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                gap: '20px 40px',
            }}>
                {children}
            </div>
        </div>
    );

    const InfoItem = ({ label, value }) => (
        <p style={{ margin: 0 }}>
            <b>{label}:</b> {value || 'N/A'}
        </p>
    );

    return (
        <div style={{ padding: "20px", background: "#f4f6fb" }}>
            <div style={{ background: "#fff", padding: 20, borderRadius: 8 }}>

                {/*  MERGED HEADER + BASIC INFO */}
                <div style={{
                    display: 'flex',
                    alignItems: 'flex-start',

                    marginBottom: 20
                }}>
                    {/* LEFT SIDE */}
                    <div style={{ flex: 1 }}>
                        <h2 style={{
                            margin: 5,
                            color: '#007BFF',
                            fontSize: '24px',
                            padding: '8px 0',
                            borderBottom: '2px solid #F1F1F1',
                        }}>
                            Student Profile
                        </h2>

                        {/*  BASIC INFO INSIDE HEADER */}
                        <div style={{
                            marginTop: 30,
                            display: 'grid',
                            gridTemplateColumns: '1fr 1fr',
                            gap: '90px 180px'
                        }}>
                            <div>
                                <InfoItem label="Name" value={data.studentName} />
                                <InfoItem label="Admission No" value={data.admissionNo} />
                                <InfoItem label="Session" value={data.session} />
                            </div>
                            <div>
                                <InfoItem label="Status" value={data.status} />
                                <InfoItem label="Regd No" value={data.regdNo} />
                                <InfoItem label="Class" value={data.classSection} />
                            </div>
                        </div>
                    </div>

                    {/* RIGHT SIDE IMAGE */}
                    {data.photo && (
                        <div style={{ flexShrink: 0 }}>
                            <div style={{
                                width: 140,
                                height: 180,
                                border: '6px solid #007BFF',
                                borderRadius: '8px',
                                overflow: 'hidden',
                                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                boxShadow: '0 8px 25px rgba(0,123,255,0.15)',
                            }}>
                                <img
                                    src={data.photo}
                                    alt="Student"
                                    style={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'cover',
                                    }}
                                />
                            </div>
                        </div>
                    )}
                </div>

                {/* OTHER SECTIONS */}
                <GridSection title="Parents Info">
                    <div>
                        <InfoItem label="Father Name" value={data.fatherName} />
                        <InfoItem label="Mother Name" value={data.motherName} />
                    </div>
                    <div>
                        <InfoItem label="Father Aadhar No" value={data.fatherAadharNo} />
                        <InfoItem label="Mother Aadhar No" value={data.motherAadharNo} />
                    </div>
                </GridSection>

                <GridSection title="Personal Info">
                    <div>
                        <InfoItem label="DOB" value={data.dob} />
                        <InfoItem label="Blood Group" value={data.bloodGroup} />
                        <InfoItem label="Religion" value={data.religion} />
                    </div>
                    <div>
                        <InfoItem label="Gender" value={data.gender} />
                        <InfoItem label="Social Category" value={data.socialCatagory} />
                        <InfoItem label="Nationality" value={data.nationality} />
                    </div>
                </GridSection>

                <GridSection title="Permanent Address">
                    <div>
                        <InfoItem label="Address" value={data.p_address} />
                        <InfoItem label="State" value={data.p_state} />
                        <InfoItem label="Phone" value={data.p_phone} />
                    </div>
                    <div>
                        <InfoItem label="City" value={data.p_city} />
                        <InfoItem label="Pincode" value={data.p_pin} />
                        <InfoItem label="Mobile" value={data.p_mobile} />
                    </div>
                </GridSection>

                <GridSection title="Present Address">
                    <div>
                        <InfoItem label="Address" value={data.c_address} />
                        <InfoItem label="State" value={data.c_state} />
                        <InfoItem label="Phone" value={data.c_phone} />
                    </div>
                    <div>
                        <InfoItem label="City" value={data.c_city} />
                        <InfoItem label="Pincode" value={data.c_pin} />
                        <InfoItem label="Mobile" value={data.c_mobile} />
                    </div>
                </GridSection>

                {/* BUTTON */}
                <div style={{ textAlign: 'center', marginTop: 30 }}>
                    <button
                        style={{
                            padding: '10px 30px',
                            background: '#007bff',
                            color: 'white',
                            border: 'none',
                            borderRadius: 5,
                            cursor: 'pointer',
                        }}
                        onClick={() => navigate("/admin/students")}
                    >
                        Back to Students
                    </button>
                </div>

            </div>
        </div>
    );
}